import React from "react";
import { useEffect,useRef } from "react";
import { useLayoutEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import { toast } from "react-toastify";
import { getUser,storeLPMAdminColumns,getLPMAdminColumns} from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import Spinner from "../../common/Spinner/Spinner";
import AdminServiceRequestsGrid from "../../components/ServiceRequests/Admin/AdminServiceRequestsGrid";
import LPMFilterSection from "../../components/ServiceRequests/Admin/LPMFilterSection";
import ServiceRequestAssignmetSummaryModal from "../../components/ServiceRequests/Admin/ServiceRequestAssignmetSummaryModal";
import OutboundCallingReportActionModal from "../../components/ServiceRequests/Admin/OutboundCallingReportActionModal";
import LPMFilterModel from "../../components/ServiceRequests/Admin/LPMFilterModel";
import FacilitatorReassignmentModal from "../../components/ServiceRequests/Admin/FacilitatorReassignmentModal";

export default function AdminServiceRequestAssignmentContainer(props)
{
	const[activePage,setActivePage]=useState("");
    const history = useHistory();
	const FileInputref = React.useRef();

    let AllColumns=[
        {
			checked: true,
			label: "Service Name",
			id: "Service Name",
            code: "ServiceName",
		},
        {
			checked: true,
			label: "Package Details",
			id: "Package Details",
            code: "PackageDetails",
		},
        {
			checked: true,
			label: "Customer Details",
			id: "Customer Details",
            code: "CustomerDetails",
		},
        // {
		// 	checked: true,
		// 	label: "Handholder",
		// 	id: "Handholder",
        //     code: "Handholder",
		// },
        {
			checked: true,
			label: "Facilitator",
			id: "Facilitator",
            code: "Facilitator",
		},
        {
			checked: true,
			label: "Service Partner",
			id: "Service Partner",
            code: "ServicePartner",
		},
        {
			checked: true,
			label: "Created On",
			id: "Created On",
            code: "CreatedOn",
		},
        {
			checked: true,
			label: "Follow Up On",
			id: "Follow Up On",
            code: "FollowUpOn",
		},
		{
			checked: true,
			label: "Status",
			id: "Status",
            code: "Status",
		}
	];

	let SearchByOptions=[
		{
			checked: false,
			label: "Facilitator",
			id: "Facilitator",
            code: "Facilitator",
		},
        {
			checked: false,
			label: "Service Instance ID",
			id: "Service Instance ID",
            code: "ServiceInstanceID",
		},
        {
			checked: false,
			label: "Package/Program Instance ID",
			id: "Package/Program Instance ID",
            code: "PackageProgramInstanceID",
		},
        {
			checked: false,
			label: "Customer Email ID",
			id: "Customer Email ID",
            code: "CustomerEmailID",
		},
        
        {
			checked: false,
			label: "Phone Number",
			id: "Phone Number",
            code: "PhoneNumber",
		},
		{
			checked: false,
			label: "Resource Display Name",
			id: "Resource Display Name",
            code: "ResourceDisplayName",
		}
	];

    if(getLPMAdminColumns()===undefined)
    {
        storeLPMAdminColumns(AllColumns);
    }
    else
    {
        AllColumns=getLPMAdminColumns();
    }

    //Table Grid States
    const [pages, setPages] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setcurrentPage] = useState(0);
    const [tableInstance, setTableInstance] = useState(null);
    const [count, setCount ] = useState(0);
    const [pageSizeOptions,setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
        {
            value: "50",
            label: "50 Rows",
        },
        {
            value: "75",
            label: "75 Rows",
        },
        {
            value: "100",
            label: "100 Rows",
        },
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });
    //Table Grid States End

    const [ColumnDropdownList, setColumnDropdownList] = useState(AllColumns);
    const [isColumnDropdownOpen, setisColumnDropdownOpen] = useState(false);
    const toggleColumnVisibility=()=>{
        setisColumnDropdownOpen(!isColumnDropdownOpen);
    }

	const [SearchByDropdownList, setSearchByDropdownList] = useState(SearchByOptions);
    const [isSearchByDropdownOpen, setisSearchByDropdownOpen] = useState(false);
    const toggleSearchByVisibility=()=>{
        setisSearchByDropdownOpen(!isSearchByDropdownOpen);
    }

    const [isLoading, setIsLoading] = useState(false);

	const [serviceRequests, setServiceRequests] = useState([]);
	const [selectedServiceRequests, setSelectedServiceRequests] = useState([]);

	const [handholderList, setHandholderList] = useState([]);
	const [serviceNameList, setServiceNameList] = useState([]);
	const [selectedServiceNameList, setSelectedServiceNameList] = useState([]);
	const [selectedHandholder, setSelectedHandholder] = useState(null);

    const [bulkAssignServiceRequest, setBulkAssignServiceRequest] = useState([]);
    const [numberOfServices, setNumberOfServices] = useState(0);
	const [selectedServiceRequestsHasHandholder,setSelectedServiceRequestsHasHandholder,] = useState(false);

    //Filter states
	const [selectedServiceStatusListForFilter, setSelectedServiceStatusListForFilter] = useState([]);
	const [serviceStatusNameListForFilter, setServiceStatusNameListForFilter] = useState([]);

	const [showFilterModal,setshowFilterModal] = useState(false);
	const toggleFilterModal=()=>{
        setshowFilterModal(!showFilterModal);
    }
    const [clearCount, setClearCount] = useState(0);
    const [showUnassignedServiceRequests,toggleUnassignedServiceRequests,] = useState(false);
	const [showPendingFollowUpsServiceRequests,togglePendingFollowUpsServiceRequests,] = useState(false);
	const [showTatnotFollowedServiceRequests,toggleTatnotFollowedServiceRequests,] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
	const [searchFilter, setSearchFilter] = useState(null);
	const [filterError, setFilterError] = useState(false);
    const [serviceRequestStatusList, setServiceRequestStatusList] = useState([]);
    const [followUpDateTo, setFollowUpDateTo] = useState("");
	const [followUpDateFrom, setFollowUpDateFrom] = useState("");
    const [selectedServiceRequestStatusList,setSelectedServiceRequestStatusList,] = useState([]);
    const [paymentStatusList, setPaymentStatusList] = useState([
		{ checked: false, label: "Credit", id: "Credit", code: "Credit" },
		{ checked: false, label: "Failed", id: "Failed", code: "Failed" },
	]);
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState([]);
    const [MovedToSPMStatusOptions,setMovedToSPMStatusOptions,] = useState([
		/*{
			value: "all",
			label: "All",
		},*/
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
    const [selectedMovedToSPMStatus,setSelectedMovedToSPMStatus,] = useState(null);
    const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
	const [selectedServiceNameListForFilter, setSelectedServiceNameListForFilter] = useState([]);
    const [packageNameListForFilter, setPackageNameListForFilter] = useState([]);
	const [selectedPackageNameListForFilter, setSelectedPackageNameListForFilter] = useState([]);
	const [servicesThroughPackageOptions,setservicesThroughPackageOptions,] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [selectedServicesThroughPackageOption,setSelectedServicesThroughPackageOption,] = useState({
		value: "all",
		label: "All",
	});
    //End Filter states

	const [facilitatorList, setFacilitatorList] = useState([]);
	const [selectedFacilitator, setSelectedFacilitator] = useState(null);

    //Outbound Calling states
    const [outboundCallingReportFile,setOutboundCallingReportFile,] = useState();
	const [showOutboundCallingReportActionModal,setshowOutboundCallingReportActionModal] = useState(false);
	const toggleOutboundCallingReportActionModal=()=>{
        setshowOutboundCallingReportActionModal(!showOutboundCallingReportActionModal);
    }
    //Outbound Calling states end

    const [showConfirmHandholderAssignmentModal,setShowConfirmHandholderAssignmentModal,] = useState(false);

	const ColumnDropdownRef = useRef();
	const SearchDropdownRef = useRef();
	useEffect(() => {
		const interval = setInterval(() => 
		{
			if (isColumnDropdownOpen || isSearchByDropdownOpen) 
			{
			  document.addEventListener("click", close);
			} 
			else 
			{
			  document.removeEventListener("click", close);
			}

		}, 0);
		return () => {
			clearInterval(interval)
			document.removeEventListener("click", close);
		};
	});

	const close = (e) => {
		if (isColumnDropdownOpen) 
		{
			if (ColumnDropdownRef.current && ColumnDropdownRef.current.contains(e.target)) 
			{
				return;
			}
			toggleColumnVisibility()
		}
		else if(isSearchByDropdownOpen)
		{
			if (SearchDropdownRef.current && SearchDropdownRef.current.contains(e.target)) 
			{
				return;
			}
			toggleSearchByVisibility();
		}		
	};

    useEffect(() => {
		let temp = [];
		selectedServiceRequests.map((e) => {
			if (temp.includes(e.sEmailAddress) === false) 
            {
				temp.push(e.sEmailAddress);
			}
		});

		api.getAllFacilitators().then(({ data }) => {
			const f = Object.keys(data).map((e) => ({ value: e, label: e }));
			setFacilitatorList(f);
		});

		if (temp.length) 
        {
			api.assignHandholder({ email_ids: temp }).then((d) => {
				setBulkAssignServiceRequest(d.data);
				let numServices = 0;
				Object.entries(d.data).map(([key, value]) => {
					if (typeof value === "object") {
						numServices += value.length;
						value.map((x) => {
							if (x.refHH !== null) {
								setSelectedServiceRequestsHasHandholder(true);
							}
						});
					}
				});
				setNumberOfServices(numServices);
			});
		}
        else 
        {
			setSelectedServiceRequestsHasHandholder(false);
			setBulkAssignServiceRequest([]);
			setNumberOfServices(0);
		}

	}, [selectedServiceRequests]);

    useEffect(() => {
		/**
		 * fetch master list of all handholders in the system
		 */
		if (!getUser()) {
			history.push("/login");
		}
		setActivePage("LPMGrid");
		api.getAllHandholders().then(({ data }) => {
			const hh = Object.keys(data).map((hh) => ({
				value: hh,
				label: hh,
			}));
			setHandholderList(hh);
		});

		api.getDisableFalseServiceRequestsNames({
			bDisableService:false
		}).then(({ data }) => {
			const serviceReqNames = Object.keys(data).map((idx) => {
				return {
					checked: selectedServiceNameList.includes(
						data[idx].sServiceCode
					),
					label: data[idx].sServiceName,
					id: data[idx].id,
					code: data[idx].sServiceCode,
				};
			});
			setServiceNameList(serviceReqNames);
			const serviceReqNamesForFilter = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sServiceName,
					id: data[idx].id,
					value: data[idx].sServiceCode,
				};
			});
			setServiceNameListForFilter(serviceReqNamesForFilter);
		});

		api.getAllPackageCatalogues().then(({ data }) => 
		{
			const packageNamesForFilter = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sPackageOfferTitle,
					id: data[idx].id,
					value: data[idx].id,
				};
			});
			setPackageNameListForFilter(packageNamesForFilter);
		});

		api.getAllServiceRequestsStatus().then(({ data }) => {
			const serviceReqStatus = Object.keys(data).map((idx) => {
				return {
					checked: selectedServiceRequestStatusList.includes(
						data[idx].id
					),
					label: data[idx].sSRState,
					id: data[idx].sSRState,
					code: data[idx].sSRState,
				};
			});
			setServiceRequestStatusList(serviceReqStatus);

			const serviceStatus = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sSRState,
					value: data[idx].sSRState,
					id: data[idx].sSRState,
				};
			});
			setServiceStatusNameListForFilter(serviceStatus);
		});
	}, []);

    const fetchServiceRequests = (instance, flag) => {
		getAllServiceRequests(instance, flag);
	};

    useEffect(() => {
        getAllServiceRequests(tableInstance, true);
        setSelectedServiceRequests([]);        
	}, [selectedPageSizeOption]);

    const getAllServiceRequests = async (instance, flag = false) => {
		if (!instance) return;
		if (!tableInstance) setTableInstance(instance);
		try 
        {
			const { page } = instance.state ?? { page: 0 };
			let icurrentPage=page;
			if (!flag &&isNaN(icurrentPage)) return;
			const pageSize =selectedPageSizeOption.value;

			if(flag || isNaN(icurrentPage))
			{
				icurrentPage=0;
			}

			let filterParameters = {
				page:icurrentPage+1,
				page_size:pageSize,
				pagination:true,
			};

			if(currentPage!=icurrentPage)
			{
				setSelectedServiceRequests([]);
			}

			SearchByDropdownList.map((x) => {
				if (x.checked && searchTerm)
				{
					if(x.code==="Facilitator")
					{
						filterParameters.Facilitator_email= searchTerm ;
					}
					else if(x.code==="ServiceInstanceID")
					{
						filterParameters.nResourceInstanceID=searchTerm ;
					}
					else if(x.code==="PackageProgramInstanceID")
					{
						filterParameters.nPackageInstanceId=searchTerm;
					}
					else if(x.code==="CustomerEmailID")
					{
						filterParameters.C_email=searchTerm;
					}
					else if(x.code==="PhoneNumber")
					{
						filterParameters.C_phone=searchTerm ;
					}
					else if(x.code==="ResourceDisplayName")
						{
							filterParameters.ResourceDisplayName=searchTerm.trim() ;
						}	
				}
			});

			if (showUnassignedServiceRequests) 
			{
				filterParameters.unassigned_hh = showUnassignedServiceRequests;
			}

			if (showPendingFollowUpsServiceRequests) 
			{
				filterParameters.pending_follow_ups = showPendingFollowUpsServiceRequests;
			}

			if (showTatnotFollowedServiceRequests) 
			{
				filterParameters.tat_not_followed = showTatnotFollowedServiceRequests;
			}

			let serviceRequestListtemp2 = [];
			selectedServiceNameListForFilter.map((e) => {
				serviceRequestListtemp2.push(e.value);
			});
			const serviceRequestList=serviceRequestListtemp2

			let packageListtemp = [];
			selectedPackageNameListForFilter.map((e) => {
				if(e.value!="*")
				{
					packageListtemp.push(e.value);
				}
			});
			const PackageList=packageListtemp

			let servicestatusListtemp2 = [];
			selectedServiceStatusListForFilter.map((e) => {
				if(e.value!="*")
				{
					servicestatusListtemp2.push(e.value);
				}
			});
			const serviceStatusList=servicestatusListtemp2;
			const fromDate = followUpDateFrom;
			const toDate = adjustedToDate(followUpDateTo);

			if(fromDate)
			{
				filterParameters.fromDate = fromDate;
			}

			if(toDate)
			{
				filterParameters.toDate = toDate;
			}
			
			if (serviceStatusList.length)
			{
				filterParameters.statusList = serviceStatusList;
			}

			if (serviceRequestList.length)
			{
				filterParameters.service_codes = serviceRequestList;
			}

			if(selectedMovedToSPMStatus&&selectedMovedToSPMStatus.value=='yes')
			{
				filterParameters.bMovedToSPM=true;
			}
			else if(selectedMovedToSPMStatus&&selectedMovedToSPMStatus.value=='no')
			{
				filterParameters.bMovedToSPM=false;
			}

			if (PackageList.length) 
			{
				filterParameters.nPackageCatalogueIds = PackageList;
			}
			
				
			setIsLoading(true);
			const { tempServices } = api.getServiceRequests(filterParameters).then(({ data }) => {
				setIsLoading(false);
				if(data)
				{
					const { results, count } = data;
					setcurrentPage(icurrentPage);
					const totalPages = (count - 1) / pageSize + 1;                    
					setCount(count);
					setPages(Math.floor(totalPages));
					setPageSize(pageSize);
					setServiceRequests(results);
				}
				else
				{
					toast("", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				}
			}).catch((error) =>
			{
				setIsLoading(false);
				if(error.response.data.detail)
				{
					toast(String(error.response.data.detail), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				}
				else if(error.response.data.message)
				{
					toast(String(error.response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				}
				else{
					toast("Internal server error", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				}                
			});

		} catch (error) 
        {
			console.error(error);
		}
	};

	const handleFacilitatorAssigned = () => {
		if (!selectedFacilitator) {
			toast("Please select a facilitator.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (selectedServiceRequests.length === 0) return;
		const serviceRequestsUserIDs = selectedServiceRequests.map(
			(sr) => sr.nUserId
		);
		const facilitator = selectedFacilitator.value;
		const payload = {
			Facilitator: facilitator,
			user_ids: serviceRequestsUserIDs,
		};
		setIsLoading(true);
		api.assignFacilitator(payload)
			.then((response) => {
				setSelectedFacilitator(null);
				setSelectedServiceRequests([]);
				getAllServiceRequests(tableInstance,true);
				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
				} else {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
		setIsLoading(false);
	};


    const handleHandholderAssigned = () => {
		if (!selectedHandholder) {
			toast("Please select a handholder.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (selectedServiceRequests.length === 0) return;
		const serviceRequests = selectedServiceRequests.map(
			(sr) => sr.nResourceInstanceId
		);
		const handholder = selectedHandholder.value;
		const payload = {
			HH: handholder,
			nResourceInstanceIds: serviceRequests,
		};
		setIsLoading(true);
		api.assignHandholder(payload)
			.then((response) => {
				setSelectedHandholder(null);
				setSelectedServiceRequests([]);
				getAllServiceRequests(tableInstance,true);

				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
				} else {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
		setIsLoading(false);
	};

	const handleUnAssignHandholder = () => {
		const serviceRequests = selectedServiceRequests.map(
			(sr) => sr.nResourceInstanceId
		);
		const payload = { HH: null, nResourceInstanceIds: serviceRequests };
		api.assignHandholder(payload)
			.then((response) => {
				setSelectedHandholder(null);
				setSelectedServiceRequests([]);
				getAllServiceRequests(tableInstance,true);

				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
				} else {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
	};

	const downloadOutboundUploadLogs = () => {
		const data = api
			.downloadOutboundLogs()
			.then(({ data }) => {
				window.open(data["generated_file"], "_self");
			})
			.catch((error) => {
				toast("Server error.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
	};

    const uploadOutboundReport = () => {
		if (!outboundCallingReportFile) return;
		var formData = new FormData();

		formData.append(
			"outbound_report",
			outboundCallingReportFile,
			outboundCallingReportFile.name
		);
		setIsLoading(true);
		const data = api
			.generateOutboundCallingLog(formData)
			.then(({ data }) => {
				window.open(data["fOutputFile"], "_self");
			})
			.then(() => {
				setIsLoading(false);
			})
			.catch((error) => {
				toast("Server error.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoading(false);
			});
	};

	const onOutboundUpload = (e) => {
		console.log("files", e.target.files);
		setOutboundCallingReportFile(e.target.files[0]);
	};

	const generateCallingReport = () => {
		const serviceRequests = selectedServiceRequests.map(
			(sr) => sr.nResourceInstanceId
		);
		api.generateCallingReport()
			.then((response) => {
				console.log(response);
				toast(response["data"]["details"], {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
	};

    const handleSearchInputChange = ({ target }) => {
		const { value } = target;
		setSearchTerm(value);
		if (searchFilter === null) 
		{
			setFilterError(true);
		}
	};

    const handleSearchClick = async () => {
		if(showFilterModal)
		{
			toggleFilterModal();
		}
		
		getAllServiceRequests(tableInstance, true);
	};

    const handleClearFilterSearch = () => {		
		setSearchTerm("");
		setSelectedMovedToSPMStatus(null);
		setSelectedServicesThroughPackageOption({
			value: "all",
			label: "All",
		});
		setSelectedServiceRequestStatusList([]);
		setSelectedPaymentStatus([]);
		setSelectedServiceNameListForFilter([]);
		setSelectedPackageNameListForFilter([]);
		setSelectedServiceStatusListForFilter([]);
		let tempPaymentStatus = paymentStatusList.map((x) => {
			x.checked = false;
			return x;
		});
		setPaymentStatusList(tempPaymentStatus);
		
		let tempSrStatus = serviceRequestStatusList.map((x) => {
			x.checked = false;
			return x;
		});
		setServiceRequestStatusList(tempSrStatus);
		
		setSearchTerm("");		
		setFollowUpDateFrom("");
		setFollowUpDateTo("");
		setSearchFilter(null);
		setClearCount(clearCount+1);	
		let tempserach = SearchByDropdownList.map((x) => {
            x.checked = false;
            return x;
        });
        setSearchByDropdownList(tempserach);
		toggleFilterModal();
	};

    useEffect(() => {
		if(clearCount>0)
		{
			getAllServiceRequests(tableInstance);
		}		
	}, [clearCount]);

    const toggleAll = () => {
		let temp = selectedServiceNameList;
		if (selectedServiceNameList.length != serviceNameList.length) {
			let tempSR = serviceNameList.map((e) => {
				if (!temp.includes(e.code)) {
					temp = temp.concat(e.code);
					e.checked = true;
				}
				return e;
			});
			setSelectedServiceNameList(temp);
			setServiceNameList(tempSR);
			getAllServiceRequests(tableInstance);
		} else {
			let tempSR = serviceNameList.map((e) => {
				e.checked = false;

				return e;
			});
			setSelectedServiceNameList([]);
			setServiceNameList(tempSR);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSelection = (e) => {
		let temp = selectedServiceNameList;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSR = serviceNameList.map((x) => {
				if (x.code === e) {
					x.checked = true;
				}
				return x;
			});
			setServiceNameList(tempSR);
			setSelectedServiceNameList(temp);
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSR = serviceNameList.map((x) => {
				if (x.code === e) {
					x.checked = false;
				}
				return x;
			});
			setServiceNameList(tempSR);
			setSelectedServiceNameList(temp);
			// getAllServiceRequests(tableInstance);
		}
	};

	const toggleStatusSelection = (e) => {
		let temp = selectedServiceRequestStatusList;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance);
		}
	};

	const togglePaymentStatus = (e) => {
		let temp = selectedPaymentStatus;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempPaymentStatus = paymentStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setPaymentStatusList(tempPaymentStatus);
			setSelectedPaymentStatus(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempPaymentStatus = paymentStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setPaymentStatusList(tempPaymentStatus);
			setSelectedPaymentStatus(temp);
			// getAllServiceRequests(tableInstance);
		}
	};

    const toggleConfirmHandholderAssignmentModal = () => {
		// if (!selectedHandholder) {
		//   toast("Please select a handholder.", {
		//     autoClose: 5000,
		//     type: toast.TYPE.ERROR,
		//   });
		//   return;
		// }
		if (selectedServiceRequests.length == 0) {
			toast("Please select service requests.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setShowConfirmHandholderAssignmentModal(
			!showConfirmHandholderAssignmentModal
		);
	};

	const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

	/*Callbacks for service filter */
	const toggleAllForFilter = () => 
	{
		let temp =[];
		
		if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length!=(serviceNameListForFilter.length+1)) 
		{
			if(selectedServiceNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedServiceNameListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = serviceNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceNameListForFilter(temp);
			setServiceNameListForFilter(tempSR);
			getAllServiceRequests(tableInstance);
		} 
		else
		{
			setSelectedServiceNameListForFilter([]);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSelectionForFilter = (e) => {
		setSelectedServiceNameListForFilter(e);
	};
	/* Callbacks for service filter */

	/*Callbacks for Package filter */
	const toggleAllForPackageFilter = () => 
	{
		let temp =[];
		
		if (selectedPackageNameListForFilter.length != packageNameListForFilter.length && selectedPackageNameListForFilter.length!=(packageNameListForFilter.length+1)) 
		{
			if(selectedPackageNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedPackageNameListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = packageNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedPackageNameListForFilter(temp);
			setPackageNameListForFilter(tempSR);
			getAllServiceRequests(tableInstance);
		} 
		else
		{
			setSelectedPackageNameListForFilter([]);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSelectionForPackageFilter = (e) => {
		setSelectedPackageNameListForFilter(e);
	};
	/* Callbacks for Package filter */

	const toggleAllForServiceStatusFilter = () => 
	{
		let temp =[];
		
		if (selectedServiceStatusListForFilter.length != serviceStatusNameListForFilter.length && selectedServiceStatusListForFilter.length!=(serviceStatusNameListForFilter.length+1)) 
		{
			if(selectedServiceStatusListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedServiceStatusListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = serviceStatusNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceStatusListForFilter(temp);
			setServiceStatusNameListForFilter(tempSR);
			//getExternalPartnerServices(tableInstance);
		} 
		else
		{
			setSelectedServiceStatusListForFilter([]);
			//getExternalPartnerServices(tableInstance);
		}
	};

	const toggleSelectionForServiceStatusFilter = (e) => {
		setSelectedServiceStatusListForFilter(e);
	};

    const toggleColumnSelection = (e) => {
		let temp = ColumnDropdownList;
		let tempSrStatus = ColumnDropdownList.map((x) => {
            if (x.code == e) {
                x.checked = !x.checked;
            }
            return x;
        });
        setColumnDropdownList(tempSrStatus);
        storeLPMAdminColumns(tempSrStatus);
	};

	const selectSearchBySelection = (e) => {
		let temp = SearchByDropdownList;
		let tempserach = SearchByDropdownList.map((x) => {
            if (x.code == e) {
                x.checked = !x.checked;
            }
			else
			{
				x.checked = false;
			}
            return x;
        });
        setSearchByDropdownList(tempserach);
	};

	const [AssignFacilitatorFile,setAssignFacilitatorFile] = useState();
	const [isAssignFacilitatorUploadOpen, setisAssignFacilitatorUploadOpen] = useState(false);
	const handleAssignFacilitatorUploadClick = () => 
	{
		setisAssignFacilitatorUploadOpen(!isAssignFacilitatorUploadOpen);
	};

	const onAssignFacilitatorUpload = (e) => {
		console.log("files", e.target.files);
		setAssignFacilitatorFile(e.target.files[0]);
	};

	const uploadAssignFacilitatorFile = () => {
		if (!AssignFacilitatorFile) 
        {
            toast("Please select file.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
		var formData = new FormData();

		formData.append(
			"assign_facilitator_data",
			AssignFacilitatorFile,
			AssignFacilitatorFile.name
		);
		setIsLoading(true);
		const data = api
		.uploadAssignFacilitatorData(formData)
		.then(({ data }) => {
			setIsLoading(false);
			FileInputref.current.value = "";
			setAssignFacilitatorFile(null);
			if(data.message)
			{
				toast(data.message, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
			else
			{
				toast("File uploaded successful", {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
			
		})
		.catch((error) => {
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
		});
	};

	const onSelectFacilitator = (option) => {
		setSelectedFacilitator(option)
	}


    return(
            <>
			{
				activePage=="LPMGrid"?
				(
					<>
						<div className={`row ${isLoading && "set-opacity"}`}>
							{isLoading && <Spinner className="center-screen" />}
							{
								<>						
									<LPMFilterSection
										count={count}
										showCount={true}
										facilitatorList={facilitatorList}
										onSelectFacilitator={onSelectFacilitator}
										selectedFacilitator={selectedFacilitator}
										handholderList={handholderList}
										selectedHandholder={selectedHandholder}
										onSelectHandholder={setSelectedHandholder}
										numberOfServices={numberOfServices}								
										selectedServiceRequests={selectedServiceRequests}
										// onAssignHandholder={handleHandholderAssigned}
										onAssignHandholder={handleFacilitatorAssigned}
										onUnAssignHandholder={handleUnAssignHandholder}
										selectedServiceRequestsHasHandholder={selectedServiceRequestsHasHandholder}
										showUnassignedServiceRequests={showUnassignedServiceRequests}
										toggleUnassignedServiceRequests={() => {
											if (!tableInstance) return;				
											toggleUnassignedServiceRequests(
												!showUnassignedServiceRequests
											);
										}}
										showPendingFollowUpsServiceRequests={showPendingFollowUpsServiceRequests}
										togglePendingFollowUpsServiceRequests={() => {
											if (!tableInstance) return;				
											togglePendingFollowUpsServiceRequests(
												!showPendingFollowUpsServiceRequests
											);
										}}
										showTatnotFollowedServiceRequests={showTatnotFollowedServiceRequests}
										toggleTatnotFollowedServiceRequests={() => {
											if (!tableInstance) return;				
											toggleTatnotFollowedServiceRequests(
												!showTatnotFollowedServiceRequests
											);
										}}
										toggleConfirmHandholderAssignmentModal={
											toggleConfirmHandholderAssignmentModal
										}

										SearchByDropdownList={SearchByDropdownList}
										isSearchByDropdownOpen={isSearchByDropdownOpen}
										toggleSearchByVisibility={toggleSearchByVisibility}
										SearchDropdownRef={SearchDropdownRef}
										selectSearchBySelection={selectSearchBySelection}

										toggleFilterModal={toggleFilterModal}

										searchTerm={searchTerm}
										onSearchInputChange={handleSearchInputChange}
										onSearchClicked={handleSearchClick}

										toggleOutboundCallingReportActionModal={toggleOutboundCallingReportActionModal}
										handleAssignFacilitatorUploadClick={handleAssignFacilitatorUploadClick}
									/>

									<AdminServiceRequestsGrid
										ColumnDropdownList={ColumnDropdownList}
										data={serviceRequests}
										selectedServiceRequests={selectedServiceRequests}
										onSelectServiceRequest={setSelectedServiceRequests}
										onFetchServiceRequests={fetchServiceRequests}
										pages={pages}
										pageSize={pageSize}
										page={currentPage}
										pageSizeOptions={pageSizeOptions}
										selectedPageSizeOption={selectedPageSizeOption}
										onPageSizeOptionChange={(option) => {
											setSelectedPageSizeOption(option);
										}}
										// For Column dropdown
										toggleColumnVisibility={toggleColumnVisibility}
										isColumnDropdownOpen={isColumnDropdownOpen}
										toggleColumnSelection={toggleColumnSelection}
										ColumnDropdownRef={ColumnDropdownRef}
									/>
								</>
							}
						</div>

						<ServiceRequestAssignmetSummaryModal
							numberOfServices={numberOfServices}
							bulkAssignServiceRequest={bulkAssignServiceRequest}
							isOpen={showConfirmHandholderAssignmentModal}
							toggleModal={toggleConfirmHandholderAssignmentModal}
							selectedServiceRequests={selectedServiceRequests}
							selectedHandholder={selectedHandholder}
							// handleHandholderAssigned={handleHandholderAssigned}
						/>

						<OutboundCallingReportActionModal
							isOpen={showOutboundCallingReportActionModal}
							toggleModal={toggleOutboundCallingReportActionModal}
							downloadOutboundUploadLogs={downloadOutboundUploadLogs}
							uploadOutboundReport={uploadOutboundReport}
							onOutboundUpload={onOutboundUpload}
							generateCallingReport={generateCallingReport}
						/>

						<LPMFilterModel
							isOpen={showFilterModal}
							toggleModal={toggleFilterModal}

							onSearchClicked={handleSearchClick}
							onClearFilterSearch={handleClearFilterSearch}

							onMovedToPSMStatusChange={(option) => {
								setSelectedMovedToSPMStatus(option);
							}}
							MovedToSPMStatusOptions={MovedToSPMStatusOptions}
							selectedMovedToSPMStatus={selectedMovedToSPMStatus}

							followUpDateTo={followUpDateTo}
							followUpDateFrom={followUpDateFrom}
							setFollowUpDateTo={setFollowUpDateTo}
							setFollowUpDateFrom={setFollowUpDateFrom}

							toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
							toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
							selectedServiceStatusListForFilter={selectedServiceStatusListForFilter}
							serviceStatusNameListForFilter={serviceStatusNameListForFilter}

							serviceNameListForFilter={serviceNameListForFilter}
							selectedServiceNameListForFilter={selectedServiceNameListForFilter}
							toggleAllForFilter={toggleAllForFilter}
							toggleSelectionForFilter={toggleSelectionForFilter}
							
							packageNameListForFilter={packageNameListForFilter}
							selectedPackageNameListForFilter={selectedPackageNameListForFilter}
							toggleAllForPackageFilter={toggleAllForPackageFilter}
							toggleSelectionForPackageFilter={toggleSelectionForPackageFilter}
						/>

						<FacilitatorReassignmentModal
								isOpen={isAssignFacilitatorUploadOpen}
								toggleModal={handleAssignFacilitatorUploadClick}
								onAssignFacilitatorUpload={onAssignFacilitatorUpload}
								uploadAssignFacilitatorFile={uploadAssignFacilitatorFile}
								FileInputref={FileInputref}
							/>

					</>
				):("")
			}
                
            </>
    );
}